import { Card, Text, Stack, Box } from '@mantine/core';
import { IconAd } from '@tabler/icons-react';

export function AdCard() {
  return (
    <Card radius="lg" withBorder p="md">
      <Stack align="center" gap="sm" py="xl">
        <Box
          style={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            backgroundColor: 'var(--mantine-color-default)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconAd size={28} style={{ opacity: 0.5 }} />
        </Box>
        <Text size="sm" c="dimmed" ta="center">
          Ad space available
        </Text>
        <Text size="xs" c="dimmed" ta="center">
          Contact us for sponsorship opportunities
        </Text>
      </Stack>
    </Card>
  );
}
